/*
 * @Author: 吴俊杰_20717 20717@etransfar.com
 * @Date: 2022-12-25 14:00:54
 * @LastEditors: 吴俊杰_20717 20717@etransfar.com
 * @LastEditTime: 2022-12-26 14:44:17
 * @FilePath: /lytMobile/src/routes/personalInfo/index.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import React, { Component } from "react";
import { Toast, List } from "antd-mobile";
import styles from './index.less';
import { setTitle } from '../../utils/utils';
import { getShipperPartyAuthInfo, getShipperPartyInfo, getAddressList, selectContractCount, selectOrderCount, selectReceiptCount } from '../../services/personalInfo'
export default class contractManage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      authCount: 0,//身份认证收集条数
      addressCount: 0,//常用地址收集条数
      contractCount: 0,//合同收集条数
      receiptCount: 0, //回单收集条数
      orderCount: 0, //位置信息收集条数
      mobileNumber: '',  //当前用户手机号
      apiSuccess: 0,  //接口相应成功次数
    }
    setTitle('个人信息共享清单');
  }


  componentDidMount() {
    const { app_stoken } = this.props.location.query;
    console.log('query---info-----', app_stoken)
    // let app_stoken = 'ca105b15598cbbb691abdebc49386467_568731269'
    this.getShipperInfo({ app_stoken });
    this.getUserInfo({ app_stoken })
    this.getAddressCount({ app_stoken });
    this.getContractCount({ app_stoken });
    this.getOrderCount({ app_stoken });
    this.getReceiptCount({ app_stoken });
  }

  getShipperInfo = (params) => {
    getShipperPartyAuthInfo(params).then(res => {
      if (+res.code !== 0) {
        Toast.fail(res.msg);
        return;
      }
      let count = 0;
      if (res.data.businessLicenseAuthStatus !== -1) {
        count += 1;
      }
      if (res.data.legalidCardAuthStatus !== -1) {
        count += 1;
      }
      if (res.data.roadTransportAuthStatus !== -1) {
        count += 1;
      }
      this.setState({
        authCount: count,
        apiSuccess: this.state.apiSuccess + 1
      });
    })
  }

  getUserInfo = (params) => {
    getShipperPartyInfo(params).then(res => {
      if (+res.code !== 0) {
        Toast.fail(res.msg);
        return;
      }
      this.setState({
        mobileNumber: res.data.mobileNumber,
        apiSuccess: this.state.apiSuccess + 1
      });
    })
  }

  getAddressCount = (params) => {
    getAddressList({ ...params, sourceTags: '陆运通,融易运' }).then(res => {
      if (+res.code !== 0) {
        Toast.fail(res.msg);
        return;
      }
      this.setState({
        addressCount: res.count,
        apiSuccess: this.state.apiSuccess + 1
      });
    })
  }

  getContractCount = (params) => {
    selectContractCount(params).then(res => {
      if (+res.code !== 0) {
        Toast.fail(res.msg);
        return;
      }
      this.setState({
        contractCount: res.data.signedCount,
        apiSuccess: this.state.apiSuccess + 1
      });
    })
  }

  getReceiptCount = (params) => {
    selectReceiptCount(params).then(res => {
      if (+res.code !== 0) {
        Toast.fail(res.msg);
        return;
      }
      this.setState({
        receiptCount: res.data.receiptCount,
        apiSuccess: this.state.apiSuccess + 1
      });
    })
  }

  getOrderCount = (params) => {
    selectOrderCount(params).then(res => {
      if (+res.code !== 0) {
        Toast.fail(res.msg);
        return;
      }
      this.setState({
        orderCount: res.data.allOrderCount,
        apiSuccess: this.state.apiSuccess + 1
      });
    })
  }

  openPage = (page) => {
    const { authCount, addressCount, contractCount, orderCount, receiptCount, mobileNumber, apiSuccess } = this.state;
    let url = `/${page}`;
    console.log('openPage----params---', authCount, addressCount, contractCount, orderCount, receiptCount, mobileNumber);
    if (page === 'basicInfo') {
      url = url + `?authCount=${authCount}&addressCount=${addressCount}&contractCount=${contractCount}&mobileNumber=${mobileNumber}`;
    } else {
      url = url + `?authCount=${authCount}&orderCount=${orderCount}&receiptCount=${receiptCount}`;
    }
    this.props.history.push(url);
  }

  render() {
    const {apiSuccess} = this.state
    return (
      <div>
        {
          apiSuccess === 6 ?
            (
              <div className={styles.personalInfoBox}>
                <p className="title">为提供相应的产品和服务，并保障系统安全稳定运行，我们可能会收集你的相关信息：</p>
                <div className="list" onClick={() => this.openPage('basicInfo')}>
                  <div className="content">
                    <b className="content-title">基本信息</b>
                    <div className="content-des">为支持您注册账号及登录、认证身份，派车联系，我们将在您完善账号信息、进行身份认证、下单时，收集使用您的会员名、商户名称、手机号、身份信息等其他信息。</div>
                  </div>
                  <b className="arrow amd-list-arrow">{'>'}</b>
                </div>
                <div className="list" onClick={() => this.openPage('processInfo')}>
                  <div className="content">
                    <b className="content-title">使用过程信息</b>
                    <div className="content-des">为支持您完成下单、上传回单功能，我们将在您授权访问位置权限、照片权限、相机权限时，收集使用您的位置信息、图片信息。</div>
                  </div>
                  <b className="arrow amd-list-arrow">{'>'}</b>
                </div>
              </div>
            ) : (
              Toast.loading('Loading...', 1)
            )
        }
      </div>

    );
  }
}



// WEBPACK FOOTER //
// ./src/routes/personalInfo/index.js